import { Card, Col } from "reactstrap";
import { H6, Image, LI, P, UL, Ribbon } from "../../AbstractElements";
import { dynamicAPIImage } from "../../Utils";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import {
  companyprofileService,
  VIEW_COMPANY_QUERY_KEY,
} from "../../Services/companyProfileService";
import { ViewCompanyProfile } from "../../Types/CompanyProfile/CompanyProfile";

const ClientBoxGrid = () => {
  const navigate = useNavigate();
  const handleRedirect = (code: string) => {
    navigate(`${process.env.PUBLIC_URL}/client-profile/${code}`);
  };

  const { data: companiesData, isLoading: isIndustryLoading } = useQuery<{
    data: ViewCompanyProfile[];
  }>({
    queryKey: VIEW_COMPANY_QUERY_KEY,
    queryFn: companyprofileService.getAllViewCompanyProfile,
  });

  const companies: ViewCompanyProfile[] = companiesData?.data ?? [];

  return (
    <>
      {companies.map((item) => (
        <Col xl="3" sm="6" className="xl-40 box-col-3" key={"JMP"}>
          <Card>
            <div className="blog-box blog-grid text-center product-box">
              <div className="product-img">
                <Ribbon
                  className={
                    item.status === 1
                      ? "ribbon ribbon-success ribbon-bookmark ribbon-right"
                      : "ribbon ribbon-danger ribbon-bookmark ribbon-right"
                  }
                >
                  {item.status_label}
                </Ribbon>
                <Image
                  className="img-fluid top-radius-blog"
                  src={dynamicAPIImage(item.logo_url)}
                  alt={item.company || "Company Logo"}
                  style={{ width: 380, height: 380, objectFit: "cover" }}
                />

                <div className="product-hover">
                  <UL className="simple-list flex-row">
                    <LI>
                      <i
                        className="icon-book"
                        onClick={() => handleRedirect(item.code)}
                      ></i>
                    </LI>
                  </UL>
                </div>
              </div>
              <div className="blog-details-main">
                <UL className="blog-social simple-list flex-row justify-content-center">
                  <LI>{item.start_date}</LI>
                  <LI>{item.industry}</LI>
                </UL>
                <hr />
                <H6 className="f-w-600">{item.company}</H6>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </>
  );
};
export default ClientBoxGrid;
